export interface RprQueryParams {
  streetNumber?: string | null;
  streetDirection?: string | null;
  streetName?: string | null;
  streetType?: string | null;
  unitNumber?: string | null;
  city?: string | null;
  zipCode?: string | null;
}

const normalize = (v: string | null | undefined) => {
  const s = (v ?? '').replace(/\s+/g, ' ').trim();
  return s === 'Unknown' ? '' : s;
};

export function buildRprQuery(params: RprQueryParams): string {
  const {
    streetNumber,
    streetDirection,
    streetName,
    streetType,
    unitNumber,
    city,
    zipCode,
  } = params;

  const streetAddress = [streetNumber, streetDirection, streetName, streetType]
    .map(normalize)
    .filter(Boolean)
    .join(' ');

  const normalizedUnit = normalize(unitNumber);
  const aptPart = normalizedUnit ? `Apt ${normalizedUnit}` : '';

  return [streetAddress, aptPart, normalize(city), normalize(zipCode)]
    .filter(Boolean)
    .join(', ');
}
